<template>
  <div class="double-card-page-container mdl-shadow--2dp"  >
    <div class="mdl-card fill">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{'admin.accounts.label.title' | label}}</h2>
      </div>
      <div class="mdl-card__supporting-text fill">
        <data-table
          page="accounts"
          :data.sync="users"
          :selectable="table.selectable"

          :columns="table.columns"
          :sort="table.sort"
          :filter="table.filter">
          <div slot="actions">
            <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                 v-on:click="block()">{{ 'admin.accounts.button.suspend' | label}}</div>
            <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--accent"
                 v-on:click="unblock()">{{ 'admin.accounts.button.enable' | label}}</div>
          </div>
          <div slot="empty">
            <div class="empty-message">
              {{ 'admin.accounts.label.noaccounts' | label }}
            </div>
          </div>
        </data-table>
      </div>
    </div>
  </div>
</template>

<script>
  var api = require('api')
  var momentTz = require('moment-timezone')
  var makeDate = require('vue').filter('makeDate')
  module.exports = {
    ready: function () {
      this.findUsers()
    },
    components: {
      dataTable: require('c/components/Table')
    },
    methods: {
      findUsers: function () {
        var self = this
        api.User.findWithSubscription().then(function (response) {
          var users = response.data
          if (users) {
            self.users = []
          }
          users.forEach(function (user) {
            var pUser = {
              name: user.firstName + ' ' + user.lastName,
              nickname: user.nickname,
              subscriptionExpiresOn: makeDate(user.Subscription.billingPeriodEndDate, momentTz.tz.guess(), 'DD MMM YYYY HH:mm'),
              userStatus: user.status,
              subscriptionStatus: user.Subscription.status,
              id: user.id
            }
            self.users.push(pUser)
          })
        }, function (err) {
          if (err.status !== 404) {
            self.$dispatch('show-error', err.data)
          }
        })
      },
      block: function () {
        var self = this
        var ids = []
        self.users.forEach(function (user) {
          if (user.__checked) {
            ids.push(user.id)
          }
        })
        api.User.block({ids: ids}).then(function (response) {
          self.$dispatch('show-success', 'admin.accounts.suspend.success.label')
          self.$broadcast('clear-select')
          self.findUsers()
        }, function (err) {
          self.$dispatch('show-error', err.data)
        })
      },
      unblock: function () {
        var self = this
        var ids = []
        self.users.forEach(function (user) {
          if (user.__checked) {
            ids.push(user.id)
          }
        })
        api.User.unblock({ids: ids}).then(function (response) {
          self.$dispatch('show-success', 'admin.accounts.enable.success.label')
          self.$broadcast('clear-select')
          self.findUsers()
        }, function (err) {
          self.$dispatch('show-error', err.data)
        })
      }
    },
    data: function () {
      return {
        table: {
          selectable: true,
          columns: ['name', 'nickname', 'subscriptionExpiresOn', 'userStatus', 'subscriptionStatus'],
          sort: ['name', 'nickname'],
          filter: ['nickname', 'userStatus', 'subscriptionStatus']
        },
        users: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Accounts.vue?18c6aa42